import { FC } from 'react';
import BookitupTable from '../../../Atoms/BookitupTable';
import { BookitupQuestionnaire } from '../../../Types/BookitupDocument';
import QuestionnaireItem from './QuestionnaireItem';
import './QuestionnairePaneTable.css';

interface QuestionnairePaneTableProps {
  questionnaires: BookitupQuestionnaire[];
  reload: () => void;
}

const QuestionnairePaneTable: FC<QuestionnairePaneTableProps> = ({ questionnaires, reload }) => (
  <div className="questionnaire-pane-table">
    <BookitupTable>
      <thead>
        <tr>
          <th>Bezeichnung</th>
          <th className="questionnaire-pane__column--date">Datum</th>
          <th className="questionnaire-pane__column--portal">Portal</th>
          <th> </th>
        </tr>
      </thead>
      <tbody>
        {questionnaires.map((questionnaire) => (
          <QuestionnaireItem
            key={questionnaire.id}
            questionnaire={questionnaire}
            reload={reload}
            showDatum
            showPortal
            narrowPortalStatus={false}
          />
        ))}
      </tbody>
    </BookitupTable>
  </div>
);

export default QuestionnairePaneTable;
